import api from "../../../api/api.js"
import { toast } from "react-toastify";

export const getFileExt = (filename) => {
  if (!filename) return <></>;
  if (!filename) return;
  const ext = filename.split(".").pop().toLowerCase();
  return ext;
};

export const formatFileSize = (bytes) => {
  if (!bytes) return "0 B";
  if (bytes < 1024) return bytes + " B";
  else if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + " KB";
  else return (bytes / (1024 * 1024)).toFixed(2) + " MB";
}

export const formatPath = (path = "") => {
  return path.replace(/^Manually uploaded\/?/i, "");
};

export async function invokeGetApi(token, url, params = null) {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      }
    };

    // Add params only if they exist
    if (params) {
      config.params = params;
    }

    const response = await api.get(url, config);

    if (response?.status === 200 || response?.status === 201) {
      // handleSuccess?.(response.data);
      return response?.data;
    }
    return
  } catch (error) {
    console.error("GET API Error:", error);
    return
  }
}

export const invokePostApi = async (token, url, payload, newHeader = null) => {
  const headers = newHeader || {
    "Content-Type": "application/json",
    Authorization: `Token ${token}`,
  };
  try {
    const response = await api.post(
      url,
      payload,
      { headers }
    );
    return response
  } catch (error) {
    console.log(error)
    return error
  }
};

export const invokePatchApi = async (token, url, payload, newHeader = {}) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Token ${token}`,
    ...newHeader
  };
  console.log(token, url, payload, headers)
  try {
    const response = await api.patch(
      url,
      payload,
      { headers }
    );
    return response
  } catch (error) {
  }
};


export const downloadFile = async (fileUrl, fileName) => {
  try {
    const response = await fetch(fileUrl);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || 'download';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url); // cleanup
    toast.success('Download Successful')
  } catch (error) {
    console.log("Download failed:", error);
    toast.error('File cannot be downloaded')
  }
};
export const downloadFolder = async (token, folderId, folderName = "Folder") => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      params: { id: folderId },
      responseType: "blob", // Important for binary data
    };

    const response = await api.get("api/download/", config);

    if (response.status === 200 || response.status === 201) {
      // Create a blob from response
      const blob = new Blob([response.data], { type: response.data.type || "application/zip" });

      // Determine filename
      let fileName = folderName + ".zip";

      // Try to get filename from response header if available
      const contentDisposition = response.headers["content-disposition"];
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match && match[1]) fileName = match[1];
      }

      // Create a download link and click it
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Release the object URL to free memory
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error("Folder download failed:", error);
  }
};

export const logAccess = async (token, type, id) => {
  if (!type || !id) return;
  const payload = {
    object_type: type,
    object_id: id
  };
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Token ${token}`,
  };
  try {
    const response = await api.post(
      `log-access/`,
      payload,
      { headers }
    );
    if (response.status === 200 || response.status === 201) {
    }
  } catch (error) {
    console.log(error)
  }
};





